import { render, staticRenderFns } from "./Webrtc.vue?vue&type=template&id=0f6fd4bf&scoped=true&"
import script from "./Webrtc.vue?vue&type=script&lang=js&"
export * from "./Webrtc.vue?vue&type=script&lang=js&"
import style0 from "./Webrtc.vue?vue&type=style&index=0&id=0f6fd4bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6fd4bf",
  null
  
)

export default component.exports